import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { fetchPaivat } from './supabaseClient';

(async function init() {
  try {
    const data = await fetchPaivat();
    console.log('fetchPaivat result', data);
  } catch (err) {
    console.error('fetchPaivat failed', err);
  }

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
})();